import { Table } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import AgentBranchCell from '../components/AgentBranchCell';
import TrendCell from '../components/TrendCell';

export default function ProductionRateTableRow({ row }) {
  const {
    id,
    agent,
    branch,
    production_rate,
    appraised,
    entered,
    fallen,
    in_progress,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          branchName={branch?.name}
          image={agent?.profile_picture}
          relativeSelector="#production-rate-modal"
          withImage
          withBranch
          withBoldTitle
          modal="productionRate"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={production_rate?.value}
          variation={production_rate?.variation}
          percentageStatus={production_rate?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={appraised?.value}
          variation={appraised?.variation}
          percentageStatus={appraised?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={entered?.value}
          variation={entered?.variation}
          percentageStatus={entered?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={fallen?.value}
          variation={fallen?.variation}
          percentageStatus={fallen?.percentage_status}
          invertColors
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell value={in_progress?.value} hideTrend />
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
